import { useContext } from 'react';
import { useIsNarrowViewport } from '../../hooks/useIsNarrowViewport';
import { useMcpBridge } from '../../mcp/McpBridgeProvider';
import { PanelStoreContext } from '../providers/PanelStoreProvider';

/** True where the dual panel actually renders: `DualPanelLayout` and `PanelBoundary` must agree. */
export const useCanSplitLayout = (): boolean => {
  const hasPanelStore = useContext(PanelStoreContext) !== null;
  const isNarrow = useIsNarrowViewport();
  const { isInIframe } = useMcpBridge();

  return hasPanelStore && !isNarrow && !isInIframe;
};
